import { Stack } from '@mui/material';
import { useState } from 'react';
import { useComponentResponsiveProps } from '../../hooks/useComponentResponsiveProps';
import { InventoryCategory } from '../models/InventoryCategory';
import { getSectorColor } from '../utils';
import { ChartLegend } from './ChartLegend';
import { PieChart } from './PieChart';

type Props = {
  title?: string;
  category: InventoryCategory;
  disableAnimation?: boolean;
};

type ResponsiveContentType = {
  chartRadius: number;
  chartWidth: number;
  stackDirection: 'column' | 'row-reverse';
  alignItems: 'center' | 'flex-start';
};

export const ChartContent = ({ title, category, disableAnimation = false }: Props) => {
  const [activeIndex, setActiveIndex] = useState<number>();

  const [responsiveContainerRef, responsiveData] = useComponentResponsiveProps<ResponsiveContentType, HTMLDivElement>({
    xs: {
      chartRadius: 90,
      chartWidth: 35,
      stackDirection: 'column',
      alignItems: 'center',
    },
    sm: {
      chartRadius: 120,
      chartWidth: 40,
      stackDirection: 'row-reverse',
      alignItems: 'flex-start',
    },
  });

  return (
    <Stack
      data-role="chart-container"
      ref={responsiveContainerRef}
      direction={responsiveData.stackDirection}
      spacing={2}
      sx={{
        '& > *': {
          flex: 1,
        },
        alignItems: responsiveData.alignItems,
      }}
    >
      <Stack justifyContent={'center'} alignItems={'center'}>
        <PieChart
          title={title}
          data={category.getLines().map((line, index) => ({
            amount: line.getCount(),
            name: line.getName(),
            color: getSectorColor(index),
          }))}
          radius={responsiveData.chartRadius}
          chartWidth={responsiveData.chartWidth}
          onMouseEnter={(index) => setActiveIndex(index)}
          onMouseLeave={() => setActiveIndex(undefined)}
          activeIndex={activeIndex}
          disableAnimation={disableAnimation}
        />
      </Stack>

      <ChartLegend
        lines={category.getLines()}
        onMouseEnter={(index) => setActiveIndex(index)}
        onMouseLeave={() => setActiveIndex(undefined)}
        activeIndex={activeIndex}
        disableAnimation={disableAnimation}
      />
    </Stack>
  );
};
